class MemoryCache {
  constructor(initialData = {}) {
    this.cache = new Map(Object.entries(initialData));
    this.subs = [];
  }

  get(key) {
    const _key = this.serializeKey(key);
    return this.cache.get(_key);
  }

  set(key, value) {
    const _key = this.serializeKey(key);
    this.cache.set(_key, value);
    this.notify();
  }

  keys() {
    return Array.from(this.cache.keys());
  }

  has(key) {
    const _key = this.serializeKey(key);
    return this.cache.has(_key);
  }

  clear() {
    this.cache.clear();
    this.notify();
  }

  delete(key) {
    const _key = this.serializeKey(key);
    this.cache.delete(_key);
    this.notify();
  }

  serializeKey(key) {
    if (typeof key === "function") {
      try {
        key = key();
      } catch (err) {
        // dependencies not ready
        key = "";
      }
    }

    // convert null to ''
    key = key || "";

    return key;
  }

  subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error("Expected the listener to be a function.");
    }

    let isSubscribed = true;
    this.subs.push(listener);

    return () => {
      if (!isSubscribed) return;
      isSubscribed = false;
      const index = this.subs.indexOf(listener);
      if (index > -1) {
        this.subs[index] = this.subs[this.subs.length - 1];
        this.subs.length--;
      }
    };
  }

  // Notify Cache subscribers about a change in the cache
  notify() {
    for (let listener of this.subs) {
      listener();
    }
  }
}

// eslint-disable-next-line kf/const-naming-convention
export const memoryCache = new MemoryCache();
